var EditorType;
(function (EditorType) {
    EditorType["Wyziwyg"] = "WYZIWYG";
    EditorType["TextArea"] = "TEXTAREA";
})(EditorType || (EditorType = {}));

export { EditorType };
//# sourceMappingURL=base-component-type.js.map
